"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialNetworkEnum = void 0;
var SocialNetworkEnum;
(function (SocialNetworkEnum) {
  SocialNetworkEnum[SocialNetworkEnum["google"] = 1] = "google";
  SocialNetworkEnum[SocialNetworkEnum["twitter"] = 2] = "twitter";
  SocialNetworkEnum[SocialNetworkEnum["facebook"] = 3] = "facebook";
  SocialNetworkEnum[SocialNetworkEnum["instagram"] = 4] = "instagram";
  SocialNetworkEnum[SocialNetworkEnum["vkontakte"] = 5] = "vkontakte";
  SocialNetworkEnum[SocialNetworkEnum["pinterest"] = 6] = "pinterest";
  SocialNetworkEnum[SocialNetworkEnum["linkedin"] = 7] = "linkedin";
  SocialNetworkEnum[SocialNetworkEnum["apple"] = 8] = "apple";
})(SocialNetworkEnum = exports.SocialNetworkEnum || (exports.SocialNetworkEnum = {}));
